module.exports = [
  'StylistService', 'RESTService',
  (StylistService, RESTService) ->
    (salonId, stylistId) ->
      RESTService.service('schedule_breaks', StylistService(salonId).one(stylistId))
]
